/* eslint-disable no-param-reassign */
import { Box } from '@mui/joy'
import useChangeAnchorOutlink from '@components/ads/Article/Taboola/hooks/useChangeAnchorOutlink'

const TaboolaIssue = () => {
	const { ref } = useChangeAnchorOutlink()

	return <Box id="taboola-hot-issue_app_stream_1x1" className="print-hide" ref={ref} />
}

export default TaboolaIssue
